// HELPERS
import { stringifyFptiProps } from '@/utils'

// CONSTANTS
import { commonModularProfileFptiProperties } from '@/constants'

export const BUSINESS_PROFILE_PAGE_SHOWN_TO_SELLER = {
  ...commonModularProfileFptiProperties,
  eventName: 'business_profile_seller_view_shown',
}

// PREVIEW START
export const EDIT_BP_PREVIEW_SHOWN_FPTI = {
  ...commonModularProfileFptiProperties,
  eventName: 'bp_edit_page_preview_shown',
}

export const BP_EDIT_PREVIEW_BACK_CLICK_FPTI = {
  ...commonModularProfileFptiProperties,
  eventName: 'bp_edit_preview_back_click',
}

export const BP_PREVIEW_BACK_CLICK_FPTI = {
  ...commonModularProfileFptiProperties,
  eventName: 'bp_seller_profile_preview_back_click',
}

export const BP_EDIT_PREVIEW_SAVE_CLICK_FPTI = {
  ...commonModularProfileFptiProperties,
  eventName: 'bp_edit_preview_save_click',
}

export const PREVIEW_CHANGES_CONT_EDITING_CLICK_FPTI = {
  ...commonModularProfileFptiProperties,
  eventName: 'bp_edit_preview_cont_editing_click',
}
// PREVIEW END

// VIEW START
export const BUSINESS_PROFILE_SELLER_VIEW_DESCRIPTION_CARD_FPTI = {
  ...commonModularProfileFptiProperties,
  eventName: 'business_profile_seller_view_description_card_click',
}

export const BUSINESS_PROFILE_SELLER_VIEW_BUSINESS_INFO_CARD_FPTI = {
  ...commonModularProfileFptiProperties,
  eventName: 'business_profile_seller_view_business_info_card_click',
}
// VIEW END

// BIZ INFO START
export const EDIT_BIZ_INFO_SAVE_BUTTON_CLICK_FPTI = stringifyFptiProps({
  ...commonModularProfileFptiProperties,
  eventName: 'bp_business_info_page_save_click',
})

export const EDIT_BIZ_INFO_SUCCESSFUL_SAVE_FPTI = {
  ...commonModularProfileFptiProperties,
  eventName: 'bp_business_info_update_success',
}
// BIZ INFO END

// DESCRIPTION START
export const EDIT_PROFILE_DESCRIPTION_SAVE_BUTTON_CLICK_FPTI =
  stringifyFptiProps({
    ...commonModularProfileFptiProperties,
    eventName: 'bp_business_description_page_save_click',
  })

export const EDIT_PROFILE_DESCRIPTION_SUCCESSFUL_SAVE_FPTI = {
  ...commonModularProfileFptiProperties,
  eventName: 'bp_business_description_update_success',
}
// DESCRIPTION END

// PHOTOS START
export const BP_SELLER_VIEW_PROFILE_PHOTO_CLICK_FPTI = {
  ...commonModularProfileFptiProperties,
  eventName: 'business_profile_seller_view_profile_photo_click',
}

export const BP_SELLER_VIEW_COVER_PHOTO_CLICK_FPTI = {
  ...commonModularProfileFptiProperties,
  eventName: 'business_profile_seller_view_cover_photo_click',
}

export const BP_PROFILE_PHOTO_CROP_SCREEN_SHOWN_FPTI = {
  ...commonModularProfileFptiProperties,
  eventName: 'bp_profile_photo_crop_screen_shown',
}

export const BP_REMOVE_PHOTO_FPTI = {
  ...commonModularProfileFptiProperties,
  eventName: 'bp_remove_photo',
}

export const BP_REMOVE_PROFILE_PHOTO_FPTI = {
  ...BP_REMOVE_PHOTO_FPTI,
  source: 'edit_profile_photo',
}

export const BP_REMOVE_COVER_PHOTO_FPTI = {
  ...BP_REMOVE_PHOTO_FPTI,
  source: 'edit_cover_photo',
}

export const BP_CHANGE_PHOTO_FPTI = {
  ...commonModularProfileFptiProperties,
  eventName: 'bp_change_photo',
}

export const BP_CHANGE_PROFILE_PHOTO_FPTI = {
  ...BP_CHANGE_PHOTO_FPTI,
  source: 'edit_profile_photo',
}

export const BP_CHANGE_COVER_PHOTO_FPTI = {
  ...BP_CHANGE_PHOTO_FPTI,
  source: 'edit_cover_photo',
}

export const BP_SAVE_PHOTO_FPTI = {
  ...commonModularProfileFptiProperties,
  eventName: 'bp_save_photo',
}

export const BP_SAVE_PROFILE_PHOTO_FPTI = {
  ...BP_SAVE_PHOTO_FPTI,
  source: 'edit_profile_photo',
}

export const BP_SAVE_COVER_PHOTO_FPTI = {
  ...BP_SAVE_PHOTO_FPTI,
  source: 'edit_cover_photo',
}

export const BP_PHOTO_UPLOAD_SUCCESS_SHOWN_FPTI = {
  ...commonModularProfileFptiProperties,
  eventName: 'bp_photo_upload_success',
}

export const BP_PHOTO_UPLOAD_ERROR_SHOWN_FPTI = {
  ...commonModularProfileFptiProperties,
  eventName: 'bp_photo_upload_error',
}

export const BP_CHOOSE_EXISTING_PROFILE_PHOTO_FPTI = {
  ...commonModularProfileFptiProperties,
  eventName: 'bp_choose_existing_photo',
  source: 'edit_profile_photo',
}

export const BP_COVER_PHOTO_CROP_SCREEN_SHOWN_FPTI = {
  ...commonModularProfileFptiProperties,
  eventName: 'bp_cover_photo_crop_screen_shown',
}

export const BP_CHOOSE_EXISTING_COVER_PHOTO_FPTI = {
  ...commonModularProfileFptiProperties,
  eventName: 'bp_choose_existing_photo',
  source: 'edit_cover_photo',
}
// PHOTOS END
